import { render, staticRenderFns } from "./reservationList.vue?vue&type=template&id=75f5f210&scoped=true&"
import script from "./reservationList.vue?vue&type=script&lang=ts&"
export * from "./reservationList.vue?vue&type=script&lang=ts&"
import style0 from "./reservationList.vue?vue&type=style&index=0&id=75f5f210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f5f210",
  null
  
)

export default component.exports